var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwimbookerLogoTexticonBlueblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 359.82 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sblogo-texticon-blueblack-linear-gradient",
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3098ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4e94"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2772af",
    d: "M93.52,42c0,5.25-4.57,8.08-10.24,8.08-5.25,0-9.03-2.36-10.71-6.14l4.88-2.83c.84,2.36,2.94,3.78,5.83,3.78,2.52,0,4.46-.84,4.46-2.94,0-4.67-14.12-2.05-14.12-11.44,0-4.93,4.25-8.03,9.61-8.03,4.3,0,7.87,2,9.71,5.46l-4.78,2.68c-.94-2.05-2.78-2.99-4.93-2.99s-3.83.89-3.83,2.78c0,4.78,14.12,1.89,14.12,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2772af",
    d: "M133.67,23.16l-8.24,26.25h-5.56l-5.46-17.69-5.51,17.69h-5.56l-8.24-26.25h5.98l5.09,18.11,5.51-18.11h5.41l5.46,18.11,5.14-18.11h5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2772af",
    d: "M137.08,15.6c0-1.99,1.63-3.62,3.62-3.62s3.62,1.63,3.62,3.62-1.63,3.62-3.62,3.62-3.62-1.68-3.62-3.62ZM137.87,23.16h5.67v26.25h-5.67v-26.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2772af",
    d: "M188.67,33.13v16.27h-5.67v-15.9c0-3.67-2-5.72-5.09-5.72-3.36,0-5.72,2.15-5.72,6.93v14.7h-5.67v-15.9c0-3.67-1.84-5.72-4.93-5.72s-5.83,2.15-5.83,6.93v14.7h-5.67v-26.25h5.67v3.15c1.68-2.57,4.25-3.83,7.51-3.83s5.93,1.52,7.45,4.15c1.73-2.73,4.51-4.15,8.03-4.15,5.93,0,9.92,4.09,9.92,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.68,36.28c0,7.77-5.93,13.81-13.07,13.81-4.09,0-7.19-1.68-9.19-4.46v3.78h-5.67V12.66h5.67v14.22c1.99-2.73,5.09-4.41,9.19-4.41,7.14,0,13.07,5.98,13.07,13.8ZM217.01,36.28c0-4.88-3.57-8.4-8.29-8.4s-8.29,3.52-8.29,8.4,3.57,8.4,8.29,8.4,8.29-3.52,8.29-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.35,36.28c0-7.82,6.19-13.8,13.86-13.8s13.86,5.98,13.86,13.8-6.14,13.81-13.86,13.81-13.86-6.04-13.86-13.81ZM248.4,36.28c0-4.78-3.57-8.29-8.19-8.29s-8.19,3.52-8.19,8.29,3.57,8.29,8.19,8.29,8.19-3.52,8.19-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,36.28c0-7.82,6.19-13.8,13.86-13.8s13.86,5.98,13.86,13.8-6.14,13.81-13.86,13.81-13.86-6.04-13.86-13.81ZM279.78,36.28c0-4.78-3.57-8.29-8.19-8.29s-8.19,3.52-8.19,8.29,3.57,8.29,8.19,8.29,8.19-3.52,8.19-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.02,49.4l-10.76-12.12v12.12h-5.67V12.66h5.67v22.1l10.18-11.6h6.93l-11.55,12.86,11.97,13.38h-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,44.89c3.15,0,5.51-1.42,6.77-3.25l4.67,2.73c-2.42,3.57-6.35,5.72-11.5,5.72-8.66,0-14.28-5.93-14.28-13.81s5.62-13.8,13.86-13.8,13.18,6.3,13.18,13.86c0,.79-.11,1.63-.21,2.36h-20.89c.89,4.09,4.2,6.19,8.4,6.19ZM335.36,34.08c-.79-4.51-4.09-6.46-7.51-6.46-4.25,0-7.14,2.52-7.93,6.46h15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82,22.68v6.14c-3.73-.26-8.08,1.47-8.08,7.35v13.23h-5.67v-26.25h5.67v4.41c1.58-3.57,4.78-4.88,8.08-4.88Z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sblogo-texticon-blueblack-linear-gradient)",
    width: 62,
    height: 62,
    rx: 9.93,
    ry: 9.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.8,31.35c-7.3,11.86-31.07,13.79-41.99,3.64l-3.63,3.16c-.33.28-.83.18-1.03-.21l-1.71-3.45c-.04-.09-.05-.19-.03-.28.01-.05.04-.1.08-.14l3.1-3.44h.01s0,0,0,0h0s-3.1-3.43-3.1-3.43c-.04-.04-.07-.09-.08-.14-.02-.09-.01-.19.03-.28l1.71-3.45c.19-.39.7-.49,1.03-.21l3.61,3.14c10.91-10.17,34.71-8.24,42.01,3.62.27.44.27,1.02,0,1.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2673b0",
    cx: 44.96,
    cy: 27.25,
    r: 2.29
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimbookerLogoTexticonBlueblack);
export default __webpack_public_path__ + "static/media/swimbooker_logo_texticon_blueblack.6e43e7d881481e81008b41f78d64bae7.svg";
export { ForwardRef as ReactComponent };